module.exports = __webpack_public_path__ + "img/applicasol.e1fad091.png";